import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Divider as DsrDivider } from '@honda-canada/design-system-react';
import themeStyles from './styles/DividerLine.styles';
const Divider = themeStyles.apply(DsrDivider, 'Divider');
const DividerLine = ({ fields }) => {
    var _a, _b;
    return (_jsx(Divider, { id: (_a = fields === null || fields === void 0 ? void 0 : fields.anchorId) === null || _a === void 0 ? void 0 : _a.value, "data-gtm-title": (_b = fields === null || fields === void 0 ? void 0 : fields.gtmTitle) === null || _b === void 0 ? void 0 : _b.value }));
};
export default DividerLine;
